export default __webpack_public_path__ + "static/media/dimensions.d17250d1.svg";